import React, {useState, useEffect} from 'react';
import './AsideMenu.css'
import config from '../../config';
import { Link } from 'react-router-dom';
import { MapPinIcon, Monument, StarsIcon, PanelsIcon, ListIcon, UsersIcon, GroupItemsIcon, TagsIcon, TickerIcon, TickerEmergencyIcon, BannerIcon, SplashscreenIcon, MapPanelsIcon, HeartRateIcon, UploadFileIcon } from '../../assets/icons/icons';
import Divider from '@mui/material/Divider';

function AsideMenu(props) {

    const alwaysOpen = !!props.alwaysOpen || false
    const [ selectedPage, setSelectedPage ] = useState(config.HOME_PAGE);

    useEffect(() => {
        setSelectedPage(window.location.pathname.slice(1))
    },[])

    

    return (
        <aside className={!alwaysOpen ? '' : 'alwaysOpen'}>
            <div className="logo-and-menu-container">
                <div className="side-menu-logo">
                </div>
                <ul>
                    <li>
                        <Link to={'/panels'} className="linkMenu" onClick={() => setSelectedPage('panels')}>
                            <div className={`side-menu-options ${selectedPage==='panels' ? 'last-voice-selected' : ''}`}>
                                <PanelsIcon/>
                                <div className={`${alwaysOpen ? '' : 'dont-'}show-name`}>Impianti</div>
                            </div>
                        </Link>
                    </li>
                    <li>
                        <Link to={'/fermate'} className="linkMenu" onClick={() => setSelectedPage('fermate')}>
                            <div className={`side-menu-options ${selectedPage==='fermate' ? 'last-voice-selected' : ''}`}>
                                <MapPinIcon/>
                                <div className={`${alwaysOpen ? '' : 'dont-'}show-name`}>Fermate</div>
                            </div>
                        </Link>
                    </li>
                    {(props.role ==='E' || props.userIsAdmin || props.role === 'MU')&&(
                        <>
                            <li>
                                <Link to={'/events'} className="linkMenu" onClick={() => setSelectedPage('events')}>
                                    <div className={`side-menu-options ${selectedPage==='events' ? 'last-voice-selected' : ''}`}>
                                        <StarsIcon/>
                                        <div className={`${alwaysOpen ? '' : 'dont-'}show-name`}>Eventi</div>
                                    </div>
                                </Link>
                            </li>
                            <li>
                                <Link to={'/pois'} className="linkMenu" onClick={() => setSelectedPage('pois')}>
                                    <div className={`side-menu-options ${selectedPage==='pois' ? 'last-voice-selected' : ''}`}>
                                        <Monument/>
                                        <div className={`${alwaysOpen ? '' : 'dont-'}show-name`}>Punti di Interesse</div>
                                    </div>
                                </Link>
                            </li>
                            <li>
                                <Link to={'/groups'} className="linkMenu" onClick={() => setSelectedPage('groups')}>
                                    <div className={`side-menu-options ${selectedPage==='groups' ? 'last-voice-selected' : ''}`}>
                                        <GroupItemsIcon/>
                                        <div className={`${alwaysOpen ? '' : 'dont-'}show-name`}>Gruppi</div>
                                    </div>
                                </Link>
                            </li>
                            <li>
                                <Link to={'/tags'} className="linkMenu" onClick={() => setSelectedPage('tags')}>
                                    <div className={`side-menu-options ${selectedPage==='tags' ? 'last-voice-selected' : ''}`}>
                                        <TagsIcon/>
                                        <div className={`${alwaysOpen ? '' : 'dont-'}show-name`}>Tags</div>
                                    </div>
                                </Link>
                            </li>
                            <li>
                                <Link to={'/tickers'} className="linkMenu" onClick={() => setSelectedPage('tickers')}>
                                    <div className={`side-menu-options ${selectedPage==='tickers' ? 'last-voice-selected' : ''}`}>
                                        <TickerIcon/>
                                        <div className={`${alwaysOpen ? '' : 'dont-'}show-name`}>Tickers</div>
                                    </div>
                                </Link>
                            </li>
                            <li>
                                <Link to={'/tickers-emergency'} className="linkMenu" onClick={() => setSelectedPage('tickers-emergency')}>
                                    <div className={`side-menu-options ${selectedPage==='tickers-emergency' ? 'last-voice-selected' : ''}`}>
                                        <TickerEmergencyIcon/>
                                        <div className={`${alwaysOpen ? '' : 'dont-'}show-name`}>Tickers Emergenza</div>
                                    </div>
                                </Link>
                            </li>
                            
                            <li>
                                <Link to={'/banners'} className="linkMenu" onClick={() => setSelectedPage('banners')}>
                                    <div className={`side-menu-options ${selectedPage==='banners' ? 'last-voice-selected' : ''}`}>
                                        <BannerIcon/>
                                        <div className={`${alwaysOpen ? '' : 'dont-'}show-name`}>Banners</div>
                                    </div>
                                </Link>
                            </li>
                            <li>
                                <Link to={'/splashscreen'} className="linkMenu" onClick={() => setSelectedPage('splashscreen')}>
                                    <div className={`side-menu-options ${selectedPage==='splashscreen' ? 'last-voice-selected' : ''}`}>
                                        <SplashscreenIcon/>
                                        <div className={`${alwaysOpen ? '' : 'dont-'}show-name`}>Splashscreen</div>
                                    </div>
                                </Link>
                            </li>
                            {props.role === 'MU'&&(<li>
                                <Link to={'/panels-status'} className="linkMenu" onClick={() => setSelectedPage('panels-status')}>
                                    <div className={`side-menu-options ${selectedPage==='panels-status' ? 'last-voice-selected' : ''}`}>
                                        <MapPanelsIcon/>
                                        <div className={`${alwaysOpen ? '' : 'dont-'}show-name`}>Mappa Impianti</div>
                                    </div>
                                </Link>
                            </li>)}
                        </>
                    )}
                    {/* <li className='submenu'>Monitoraggio
                        <ul className={`submenu`}> */}
                    {(props.role ==='M' || props.userIsAdmin)&&(
                        <>
                            <li>
                                <Link to={'/panels-status'} className="linkMenu" onClick={() => setSelectedPage('panels-status')}>
                                    <div className={`side-menu-options ${selectedPage==='panels-status' ? 'last-voice-selected' : ''}`}>
                                        <MapPanelsIcon/>
                                        <div className={`${alwaysOpen ? '' : 'dont-'}show-name`}>Mappa Impianti</div>
                                    </div>
                                </Link>
                            </li>
                            <li>
                                <Link to={'/logs'} className="linkMenu" onClick={() => setSelectedPage('logs')}>
                                    <div className={`side-menu-options ${selectedPage==='logs' ? 'last-voice-selected' : ''}`}>
                                        <ListIcon/>
                                        <div className={`${alwaysOpen ? '' : 'dont-'}show-name`}>Logs</div>
                                    </div>
                                </Link>
                            </li>
                            <li>
                                <Link to={'/status'} className="linkMenu" onClick={() => setSelectedPage('status')}>
                                    <div className={`side-menu-options ${selectedPage==='status' ? 'last-voice-selected' : ''}`}>
                                        <HeartRateIcon/>
                                        <div className={`${alwaysOpen ? '' : 'dont-'}show-name`}>Status</div>
                                    </div>
                                </Link>
                            </li>
                        </>
                    )}
                       {/*  </ul>
                    </li> */}

                    {props.userIsAdmin&&(<><Divider style={{border: '1px solid white', marginBottom: '25px'}}/>
                    <li>
                        <Link to={'/management'} className="linkMenu" onClick={() => setSelectedPage('management')}>
                            <div className={`side-menu-options ${selectedPage==='management' ? 'last-voice-selected' : ''}`}>
                                <UsersIcon/>
                                <div className={`${alwaysOpen ? '' : 'dont-'}show-name`}>Gestione Utenti</div>
                            </div>
                        </Link>
                    </li>
                    <li>
                        <Link to={'/update'} className="linkMenu" onClick={() => setSelectedPage('update')}>
                            <div className={`side-menu-options ${selectedPage==='update' ? 'last-voice-selected' : ''}`}>
                                <UploadFileIcon/>
                                <div className={`${alwaysOpen ? '' : 'dont-'}show-name`}>Aggiornamento</div>
                            </div>
                        </Link>
                    </li></>)}
                </ul>
            </div>
        </aside>
    )
}

export default AsideMenu